import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { IBookingContent, ISeatingContent, IVersionedObject } from '../../planEatApi/PlanEatFacade';
import { prettyDate } from '../../config/dateFormatting';
import { CancelCrudButtons } from '../ui/CancelCrudButtons';
import { Modal } from '../ui/Modal';
import { InputField } from '../ui/InputField';

const useStyles = makeStyles((theme: any) => ({
    subtitle:{
        display:'flex',
        justifyContent:'start',
        alignItems:'center',
        columnGap: 5,
        fontSize: 14,
        fontWeight: 400,
        color: "#374251",
        marginBottom: 10
    }
}));

interface Props {
    seating: ISeatingContent;
    bookings: IVersionedObject<IBookingContent>[];
    seatingDeletionModalHidden: boolean;
    setSeatingDeletionModalHidden: React.Dispatch<React.SetStateAction<boolean>>;
    deleteSeating : (seatingId: string) => void;
    deleteSeatingWithMsg : (seatingId: string, body: string) => void;
}
export const SeatingDeletionModal: React.FC<Props> = ({seatingDeletionModalHidden,setSeatingDeletionModalHidden,seating,bookings,deleteSeating,deleteSeatingWithMsg}) => {
    // Styling
    const classes = useStyles();

    // State
    const [bookingsOnSeating,setBookingsOnSeating] = useState(false)
    const [deletionReason,setDeletionReason] = useState("")
    const [amountOfBookingsonSeating,setAmountOfBookingsOnSeating] = useState(0)

    useEffect(() => {
        checkIfBookingsOnSeating()
    }, [seating]);

    function checkIfBookingsOnSeating(){
        var tmpBookingsOnSeating = 0;

        bookings.forEach((booking) => {
            if(booking.content.seatingId=== seating.id){
                if(booking.content.bookingItems.length > 0){
                    tmpBookingsOnSeating += booking.content.bookingItems.length;
                }
            }
        })

        if(tmpBookingsOnSeating > 0){
            setBookingsOnSeating(true)
            setAmountOfBookingsOnSeating(tmpBookingsOnSeating)
        } else {
            setBookingsOnSeating(false)
            setAmountOfBookingsOnSeating(0)
        }
    }

    const handleDeletionReasonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setDeletionReason(event.target.value);
    };
    
    function postDeleteSeatingWithMsg(){
        deleteSeatingWithMsg(seating.id,deletionReason)
    }

    function postDeleteSeating(){
        deleteSeating(seating.id)
    }

    return (
        <Modal title='Delete seating' hidden={seatingDeletionModalHidden} setHidden={setSeatingDeletionModalHidden}>
            <div>
                <div>
                    {
                        bookingsOnSeating ?
                        <div>
                            <div>
                                <div style={{fontWeight:700,fontSize:16,color:"#B00020",marginRight:5}}> This seating contains  {amountOfBookingsonSeating} bookings</div>
                                <div className={classes.subtitle}>
                                    Therefore you must reason the deletion. The message will be send to the booked people
                                </div>
                                <InputField
                                    placeholder="Deletion Reason"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={deletionReason}
                                    onChange={handleDeletionReasonChange}
                                    fullWidth
                                    required
                                />
                            </div>
                        </div>
                        :
                        <div className={classes.subtitle}>
                            Are you sure you wanna delete this seating at <b>{prettyDate(seating.seatingStart,true,true)}</b>
                        </div>
                    }
                </div>
                <div>
                    {
                        bookingsOnSeating ?
                        <CancelCrudButtons 
                            hidden={seatingDeletionModalHidden} 
                            setHidden={setSeatingDeletionModalHidden}
                            postButtonText={"Delete seating + " + amountOfBookingsonSeating + " Bookings(s)"}
                            isDelete={true}  
                            postDeleteForEntity={postDeleteSeatingWithMsg}/>
                        :
                        <CancelCrudButtons 
                            hidden={seatingDeletionModalHidden} 
                            setHidden={setSeatingDeletionModalHidden}
                            postButtonText="Delete Seating" 
                            isDelete={true}  
                            postDeleteForEntity={postDeleteSeating}/>
                    }
                </div>
            </div>
        </Modal>
    );
}